import { createSlice } from '@reduxjs/toolkit';
import { fetchSw } from '../action/wsAction';
const initialState = {
    ws: [],
    isLoaderWs: false
};
export const wsSlice = createSlice({
    initialState,
    name: 'ws',
    reducers: {},
    extraReducers: {
        [fetchSw.fulfilled.type]: (state, action) => {
            state.ws = action.payload;
            state.isLoaderWs = false;
        },
        [fetchSw.pending.type]: (state) => {
            state.isLoaderWs = true;
        }
    }
});
export default wsSlice.reducer;
